import * as types from './types';

const INITIAL_STATE = {
    error: undefined,
    meta: {
        fetching: false,
        createdAt: undefined,
        expiresAt: undefined,
    },
    data: {
        userAgent: undefined,
        ping: {},
    },
};

function _clearBrowserMeta(state) {
    return {
        ...state,
        data: {
            ...state.data,
            ping: INITIAL_STATE.data.ping,
        },
    };
}

function _fetchingBrowserMeta(state) {
    return {
        ...state,
        meta: {
            ...state.meta,
            fetching: true,
        },
    };
}

function _setBrowserMeta(state, action) {
    const {
        payload: data,
        meta = {},
        error,
    } = action;

    const newState = {
        data: {
            ...state.data,
        },
        error,
        meta: {
            ...state.meta,
            ...meta,
            fetching: false,
        },
    };

    if (data) {
        return {
            ...newState,
            data: {
                ...state.data,
                ping: {
                    ...data,
                },
            },
        };
    }

    return newState;
}

function _setBrowserUserAgent(state, action) {
    const {
        payload: userAgent,
    } = action;

    return {
        ...state,
        data: {
            ...state.data,
            userAgent,
        },
    };
}

function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.CLEAR_BROWSER_META:
            return _clearBrowserMeta(state, action);
        case types.FETCHING_BROWSER_META:
            return _fetchingBrowserMeta(state, action);
        case types.SET_BROWSER_META:
            return _setBrowserMeta(state, action);
        case types.SET_BROWSER_USER_AGENT:
            return _setBrowserUserAgent(state, action);
        default:
            return state;
    }
}

export default reducer;
